import React, {Fragment} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import MenuIcon from '@mui/icons-material/Menu';
import Button from "@mui/material/Button";
import {ROUTES} from "../../../../routes";
import {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookOpened,
  setLookPageOpened
} from "../../../../actions/lookFunctions";
import GroheFeatureButtons from "../groheNavigation/groheFeature/groheFeatureButtons";
import {getFeatureUrl, getLookIdUrl} from "../../lookNavigation/lookFunctions2";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import GroheMobileFooterFiltersButton from "./groheMobileFooterFiltersButton";
import GroheMobileFooterViewButton from "./groheMobileFooterViewButton";
import LookFeatureRevertButton from "../../lookNavigation/lookMain/lookFeature/lookFeatureRevertButton";
import {isRoomLayoutsVisible} from "../../lookNavigation/lookNavigationFunctions";

const GroheMobileFooterButtons = (props) => {

  const {intl, lookPageOpened, setLookPageOpened, history, lookActiveFeature, setLookActiveFeature,
    lastOpenedCategory, lastOpenedFeature, setLookOpened, lookActiveCategory} = props;

  const isRoomIdeasOpened = lookPageOpened === ROUTES.rooms;
  const isRoomLayoutsOpened = lookPageOpened === ROUTES.view;

  const menuButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productMenuFooterButton);
    if (lookActiveFeature || isRoomIdeasOpened) {
      setLookPageOpened(ROUTES.category);
      setLookActiveFeature(null);
      history.push(getLookIdUrl());
    } else {
      if (lastOpenedCategory && lastOpenedFeature) { // reopen category page
        setLookPageOpened("");
        setLookActiveCategory(lastOpenedCategory);
        history.push(getFeatureUrl(lastOpenedFeature, true));
      } else if (lastOpenedFeature) { // reopen feature page
        setLookPageOpened("");
        setLookActiveFeature(lastOpenedFeature);
        history.push(getFeatureUrl(lastOpenedFeature));
      } else { // close menu
        setLookPageOpened("");
        setLookOpened(null);
        setLookActiveFeature(null);
        history.push(ROUTES.home);
      }
    }
  }

  const roomLayoutsButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productRoomLayouts);
    if (isRoomLayoutsOpened) {
      setLookPageOpened(ROUTES.category);
      history.push(getLookIdUrl());
    } else {
      setLookPageOpened(ROUTES.view);
      history.push(ROUTES.view);
    }
  }

  const roomIdeasButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productRoomIdeas);
    if (isRoomIdeasOpened) {
      setLookPageOpened(ROUTES.category);
      history.push(getLookIdUrl());
    } else {
      setLookPageOpened(ROUTES.rooms);
      history.push(ROUTES.rooms);
    }
  }

  return (
    <Fragment>
      {lookActiveCategory ? (
        <Fragment>
          <GroheMobileFooterFiltersButton/>
          <GroheMobileFooterViewButton/>
          <LookFeatureRevertButton/>
        </Fragment>
      ) : null}
      {lookActiveFeature ? <GroheFeatureButtons/> : (
        <Fragment>
          {isRoomLayoutsVisible() ? (
            <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding"
              + (isRoomLayoutsOpened ? " look-button--grohe-active" : "")}
                    variant="outlined" onClick={roomLayoutsButtonClick}>
              <FormattedMessage id={isRoomLayoutsOpened ? "grohe.menu.backToShop" : "buttons.roomLayouts"}/>
            </Button>
          ) : null}
          <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding"
          + (isRoomIdeasOpened ? " look-button--grohe-active" : "")}
                  variant="outlined" onClick={roomIdeasButtonClick}>
            <FormattedMessage id={isRoomIdeasOpened ? "grohe.menu.backToShop" : "buttons.roomIdeas"}/>
          </Button>
        </Fragment>
      )}
      <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                  className={"gm-footer__menu look-icon look-button look-button--secondary look-button--no-radius"
                    + (lookPageOpened === ROUTES.category ? " look-icon--active" : "")}
                  onClick={menuButtonClick}>
        <MenuIcon />
      </IconButton>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened, lookActiveFeature, lookActiveCategory} = store.lookState;
  const {lastOpenedFeature, lastOpenedCategory} = store.groheState;
  return {
    lookPageOpened,
    lookActiveFeature,
    lastOpenedFeature,
    lastOpenedCategory,
    lookActiveCategory,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookActiveFeature,
  setLookOpened
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheMobileFooterButtons)
  )
);
